import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './InvolvedAddressesEvBooking.html?raw';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import lang from 'dojo/_base/lang';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import { InvolvedAddressesEvBookingEditor } from "../../_loadingHelpers/VAMv2";
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';

class InvolvedAddressesEvBooking extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private btnNew: HTMLElement;

    private currentBooking: VAM2types.EvBooking_Extended;
    private tableContainer: HTMLDivElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;

    private store: MdsLax<InstanceType<typeof EntityStore<VAM2types.InvolvedAddressEvBooking>>>;

    private crud: VAM2types.CrudPrivilages = null;

    private deleteAddress() {

        this.emitDataChanged();
    }

    private _onClickNew() {
        if (!this.crud.hasCreate) return;

        let entityId = this.addNewAddressEntry();
        this._prepareEditor(entityId);
    }
    private addNewAddressEntry(): string {

        let newId = (Math.random() * 100000).toString();
        let newEntry: Partial<VAM2types.InvolvedAddressEvBooking> = {
            ref_ev_booking: this.currentBooking,
            ID: newId,
            is_active: true            
        }
        this.store.addEntry(newEntry as any, "new");
        return newId;
    }

    private _onClick_EditBtn(rowGr: StaticTable.StaticTableRowGroup<VAM2types.InvolvedAddressEvBooking>) {

        let entityId = rowGr.entity.ID;
        this._prepareEditor(entityId);
    }

    private _onTableRowClick(row: StaticTable.StaticTableRow<VAM2types.InvolvedAddressEvBooking>) {

        let entityId = row.rowGroup.entity.ID;
        this._prepareEditor(entityId);
    }

    private _prepareEditor(entityId: string) {
        if (!this.crud.hasEdit) return;
        this.StandbyStart();
        if (this.store.isEntityNew(entityId)) {

            this.openEditor(entityId);
            return;
        }
        this.RequestManager.callfunction(
            "Webtool_API__EvBooking__InvolvedAddressesEvBooking_GetAddressesDataByID",
            { entityId: entityId },
            lang.hitch(this, this.openEditor, entityId),
            (err) => {
                this.showToast(err.Message);
                this.StandbyStop();
            }
        )
    }
    private openEditor(entityId, response?) {
        this.StandbyStop();

        let form = new InvolvedAddressesEvBookingEditor();
        let heading = "";

        form.setBookingId(this.currentBooking.ID);

        if (response) {
            form.setData(response);
            heading = response["$Displayname"];
        } else {

            form.setStartupState("ready");
            heading = this.translate(`InvolvedAddress_Heading_AddNew`);
            form.setIsNew(true);
        }

        if (this.store.isEntityChanged(entityId) || this.store.isEntityNew(entityId)) form.applyAllreadyChangedData(this.store.getEntityById(entityId));


        let dlg = new GenericDialog();

        dlg.show(form,
            heading,
            null,
            null,
            "okcancel",
            (result) => {
                if (result === 1) form.externalEventHandler("ok");
                else {
                    if (this.store.isEntityNew(entityId)) {
                        this.store.deleteEntry(entityId);
                    }
                    dlg.close();
                }
            },
            {
                keepOpen: true,
                closeOnEnter: false,                
            });

        form.on("okClicked", (data: { ID: string, changedData: Object }) => {
            
            let existingEntry: VAM2types.InvolvedAddressEvBooking = null;
            
            if (this.store.isEntityExisting(data.ID, "ID", true)) {

                existingEntry = this.store.getEntityById(data.ID);

                for (let p in data.changedData) {

                    switch (p) {
                        
                        default: 
                            if (data.changedData[p] !== existingEntry[p]) existingEntry[p] = data.changedData[p];
                    }

                }
            }
            console.debug("IAB CHANGED DATA", data.changedData, "entry", existingEntry);
            this.store.changeEntry(existingEntry, true);
            this.updateTable();
            dlg.close();

            this.emitDataChanged();
        })
    }

    private emitDataChanged() {

        let data = this.store.getDiffData();

        this.emit("InvolvedAddresses_DataChanged", data);
    }

    private _onClickReload() {
        this._reload();
    }
    private _reload(): void {

        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API__EvBooking__InvolvedAddressesEvBooking_GetList",
            { bookingID: this.currentBooking.ID },
            lang.hitch(this, this._onReloadResponse),
            (err) => {
                this.showToast(err.Message);
                this.StandbyStop();
            });
    }
    private _onReloadResponse(response: Array<VAM2types.InvolvedAddressEvBooking>): void {
        this.StandbyStop();
        this.store.setup(response);
        this.updateTable();
        this.emit("reloaded");
    }

    setData(addressesList): void {
        if (!this.crud.hasRead) return;
        this.store.setup(addressesList);
    }
    hasData(): boolean {
        return this.store.getCurrentCompleteList().length > 0;
    }

    private _setUpTable(response: { layouts: Array<any> }) {
        if (this.table != null) this.table.destroy();

        this.table = new StaticTable();
        this.table.placeAt(this.tableContainer);

        this.table.setLayout(response.layouts[0]);
        this.table.setRowClick(lang.hitch(this, this._onTableRowClick));
        if (this.crud.hasEdit) this.table.addDefaultRowActionButton("edit", lang.hitch(this, this._onClick_EditBtn))
        if (this.crud.hasDelete) this.table.addDefaultRowActionButton("delete", lang.hitch(this, this.deleteAddress));
        this.table.setCyAttribute("InvolvedAddressesList");
        this.updateTable();
        this.StandbyStop();
    }
    private updateTable() {

        this.table.setupFromStore(this.store);
        //this.emit("InvolvedAddresses_TableUpdate", this.entryList.length > 0);

    //    this.entryList?.forEach(d => {
    //        if (d.toDelete === true) {
    //            this.disableNode(this.table.getRowGroupByKeyValue(d.ID, "ID").rows[0].node);
    //        }
    //    });
    }

    setCurrentBooking(booking: VAM2types.EvBooking_Extended) {
        this.currentBooking = booking;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.store = new EntityStore();

        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API__EvBooking__InvolvedAddressesEvBooking_GetTableLayout",
            null,
            lang.hitch(this, this._setUpTable),
            (err) => {
                this.showToast(err.Message);
                this.StandbyStop();
            }
        )


        this.crud = {
            hasRead: this.hasUserRole("EvBooking_InvolvedAddresses_Read"),
            hasEdit: this.hasUserRole("EvBooking_InvolvedAddresses_Edit"),
            hasCreate: this.hasUserRole("EvBooking_InvolvedAddresses_Create"),
            hasDelete: this.hasUserRole("EvBooking_InvolvedAddresses_Delete")
        }

        this.disableNode(this.btnNew, !this.crud.hasCreate);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(InvolvedAddressesEvBooking);